import styled from 'styled-components';

export default styled.div`
  flex: ${({ viewOnly }) => viewOnly ? 'none' : '1 1 0'};
  padding: 0 0 50px;
`;
